/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { Button, DialogActions, DialogTitle, DialogContentText, Dialog } from '@material-ui/core'
import { Header2 } from '@flatsy/core/MaterialUi/Typo'
import clsx from 'clsx'
import i18n from '@flatsy/utils/translations'
import { ButtonError } from '../../../MaterialUi/Button'
import LayoutDialogContent from '../Content'
import { useStyles } from './Style'
import { MainProps } from './Type'
import { Transition } from './Utils'
import { toNameCase } from '../../../MaterialUi/Typo/Utile'

const LayoutDialog: React.FC<MainProps> = ({
  open,
  title,
  endTitle,
  children,
  onClose,
  onConfirm,
  confirmLabel,
  closeLabel,
  customButtons,
  addButtons,
  disableConfirm,
  disableClose,
  noAction,
  actionSeverity,
  isMobile,
  unMount,
  bottomComponent,
  backgroundWhite,
  ...props
}) => {
  const classes = useStyles()

  const isKeepMounted = () => {
    if (unMount) return false
    return true
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={isMobile ? Transition : undefined}
      maxWidth="md"
      {...props}
      keepMounted={isKeepMounted()}
      className={clsx(classes.main, props.className && props.className)}
    >
      <div className={classes.row}>
        <DialogTitle className={backgroundWhite ? classes.dialogTitleWhite : classes.dialogTitle}>
          <Header2 lowerCase>{title ? toNameCase(title) : ''}</Header2>
        </DialogTitle>
        {endTitle}
      </div>
      <LayoutDialogContent backgroundWhite={backgroundWhite}>
        <DialogContentText component="div">{children}</DialogContentText>
      </LayoutDialogContent>
      {!noAction && (
        <DialogActions
          className={bottomComponent ? classes.dialogActionCustom : classes.dialogAction}
        >
          {customButtons ? (
            customButtons.map((singleButton) => singleButton)
          ) : (
            <>
              {bottomComponent && bottomComponent}
              <div className={classes.buttonContainer}>
                <Button
                  variant="outlined"
                  onClick={onClose}
                  disableElevation
                  disabled={disableClose}
                >
                  {closeLabel || i18n.t('close')}
                </Button>
                {onConfirm &&
                  (actionSeverity ? (
                    actionSeverity === 'high' && (
                      <ButtonError
                        className={classes.btnConfirm}
                        onClick={onConfirm}
                        disabled={disableConfirm}
                      >
                        {confirmLabel || 'Ok'}
                      </ButtonError>
                    )
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={onConfirm}
                      disableElevation
                      disabled={disableConfirm}
                      className={classes.btnConfirm}
                    >
                      {confirmLabel || 'Ok'}
                    </Button>
                  ))}
                {addButtons && addButtons.map((singleButton) => singleButton)}
              </div>
            </>
          )}
        </DialogActions>
      )}
    </Dialog>
  )
}

export default LayoutDialog
